import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-83a1f31e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "c-magic-line inline" }
const _hoisted_2 = { class: "w-full mt-x1" }
const _hoisted_3 = {
  key: "showAllResults",
  class: "search-product"
}
const _hoisted_4 = { class: "o-aspect-ratio-7/3 w-full" }
const _hoisted_5 = { class: "absolute inset-x2" }
const _hoisted_6 = { class: "flex justify-center items-center h-full" }
const _hoisted_7 = { class: "c-magic-line" }

import { computed, toRef, watch } from 'vue';
import utilities from '@/shared/utilities.service';
import breakpointsState from '@/core/responsive/breakpoints/breakpoints-state.observable';
import useProductSpotLegacyDataMapping, { ProductSpotSearchResultLegacy } from '@/shared/product/spot/useProductSpotLegacyDataMapping';
import ProductSpot from '@/shared/product/spot/ui/ProductSpot.vue';
import useGlobalLabels from '@/shared/content/useGlobalLabels';
import { GlobalLabels } from '@/shared/content/site-context.store';
import useSearch from '@/shared/search/useSearch';
import navigationStore from '@/shared/navigation/navigation.store';
import useFreightInformation from '@/shared/product/freight-information/useFreightInformation';
import useNetPrices from '@/b2b/product/useNetPrices';
import { ProductSpotModel } from '@/types/productServerApi';
import useSearchTracking from '@/shared/tracking/useSearchTracking';
import gtmService from '@/shared/tracking/gtm.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchResultProducts',
  props: {
    title: null,
    products: null
  },
  setup(__props: any) {

const props = __props as {
    title: string;
    products: ProductSpotSearchResultLegacy[];
}

const { fetchHasFreightInformation } = useFreightInformation();
const { legacyToNew } = useProductSpotLegacyDataMapping();
const { searchPageLink, term } = useSearch();
const { fetchNetPrices } = useNetPrices();

const globalLabels = useGlobalLabels(GlobalLabels.search);

const { clickedSearchResultProduct } = useSearchTracking();



const productsLimitedByBreakpoint = computed(() => {
    const bp = breakpointsState.activeBreakpoint;
    const caps = {
        md: 2,
        xl: 3,
        xxl: 5,
    };
    const cap = caps[bp] || 5;
    return utilities.toggleCollectionCap(props.products, cap, false);
});

const handleChangedProductResult = () => {
    readyToFetchHasFreightInformation();
    fetchNetPrices(productsLimitedByBreakpoint.value.map((item) => item.id));
    gtmService.viewItemList(productsLimitedByBreakpoint.value, { itemListId: 'search_suggest', itemListName: 'Search Suggest' });
};

const readyToFetchHasFreightInformation = () => {
    const products = productsLimitedByBreakpoint.value.map((item) => item.id);
    fetchHasFreightInformation(products);
};

const showAllProductsIsVisible = computed(() => {
    if (!searchPageLink.value) { return false; }
    return productsLimitedByBreakpoint.value.length < props.products.length;
});

const products = toRef(props, 'products');

const handleTracking = (product: ProductSpotModel, index: number) => {
    clickedSearchResultProduct(term.value, product);
    gtmService.selectItem(product, { itemListId: 'search_suggest', itemListName: 'Search Suggest', index });
};

watch(products, handleChangedProductResult, { immediate: true });

return (_ctx: any,_cache: any) => {
  const _component_RouterLinkConditional = _resolveComponent("RouterLinkConditional")!
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_openBlock(), _createElementBlock("li", null, [
    _createVNode(_component_RouterLinkConditional, {
      to: _unref(searchPageLink),
      title: __props.title,
      class: "text-center w-full",
      onKeydownPassive: _cache[0] || (_cache[0] = _withKeys(($event: any) => (_unref(navigationStore).toggleActiveMainNavigationItem(null)), ["enter"])),
      onClickPassive: _cache[1] || (_cache[1] = ($event: any) => (_unref(navigationStore).toggleActiveMainNavigationItem(null)))
    }, {
      default: _withCtx(() => [
        _createElementVNode("h2", _hoisted_1, _toDisplayString(__props.title), 1)
      ]),
      _: 1
    }, 8, ["to", "title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", {
        class: _normalizeClass(["search-products o-scrollbar", { 'search-products--fill-width': _unref(products).length >= 3 }])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productsLimitedByBreakpoint), (product, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: product.id,
            class: "search-product"
          }, [
            _createVNode(ProductSpot, {
              product: _unref(legacyToNew)(product),
              onClickPassive: ($event: any) => (handleTracking(_unref(legacyToNew)(product), index))
            }, null, 8, ["product", "onClickPassive"])
          ]))
        }), 128)),
        (_unref(showAllProductsIsVisible))
          ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
              _createVNode(_component_RouterLinkConditional, {
                to: _unref(searchPageLink),
                title: __props.title,
                class: "relative bg-wild-sand w-full py-70 px-15 sm:py-80 sm:px-35 md:py-150 md:px-30",
                onKeydownPassive: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_unref(navigationStore).toggleActiveMainNavigationItem(null)), ["enter"])),
                onClickPassive: _cache[3] || (_cache[3] = ($event: any) => (_unref(navigationStore).toggleActiveMainNavigationItem(null)))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("p", _hoisted_6, [
                        _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(globalLabels).showMoreProducts), 1),
                        _createVNode(_component_c_icon, {
                          name: "icon-arrow-small",
                          class: "h-8 mt-2 xl:mt-0"
                        })
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["to", "title"])
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ])
  ]))
}
}

})